function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-bus_svg__a",
  d: "M13.501 23c.826 0 1.499.673 1.499 1.5s-.673 1.5-1.499 1.5C12.674 26 12 25.327 12 24.5s.674-1.5 1.501-1.5zm11 0c.826 0 1.499.673 1.499 1.5s-.673 1.5-1.499 1.5C23.674 26 23 25.327 23 24.5s.674-1.5 1.501-1.5zM23 10a1 1 0 110 2h-8a1 1 0 110-2zM10.54 9H27.46c.292 0 .54.221.54.481V13H10V9.481c0-.26.246-.481.538-.481zM10 20h18v-5H10v5zm0 7h18v-5H10v5zM27.461 7H10.54C9.14 7 8 8.113 8 9.481V28a1 1 0 001 1v1a1 1 0 001 1h4a1 1 0 001-1v-1h8v1a1 1 0 001 1h4a1 1 0 001-1v-1a1 1 0 001-1V9.481C30 8.113 28.861 7 27.461 7zM19 36C9.626 36 2 28.374 2 19 2 9.626 9.626 2 19 2c9.374 0 17 7.626 17 17 0 9.374-7.626 17-17 17m0-36C8.507 0 0 8.507 0 19s8.507 19 19 19 19-8.507 19-19S29.493 0 19 0"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-bus_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-bus_svg__a"
})), React.createElement("use", {
  xlinkHref: "#icon-bus_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-bus_svg__b)"
}, React.createElement("path", {
  d: "M0 0h38v38H0z"
})), React.createElement("text", {
  fontFamily: "SourceSansPro-SemiBold, Source Sans Pro",
  fontSize: 20,
  fontWeight: 500,
  mask: "url(#icon-bus_svg__b)"
}, React.createElement("tspan", {
  x: -33.2,
  y: 26
}, "Icons")));

var SvgIconBus = function SvgIconBus(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconBus;